export enum IdentityDocumentTypeEnum {
  Undefined = 0,
  IdentityCard = 1,
  Passport = 2,
  OtherIdentityDocument = 3
}
